import { BreadcrumbData } from '~/features/shared/breadcrumbList/types'

export const getBreadcrumb = (
  username: string,
  nickname: string,
  folderName: string,
  shop?: {
    id: number
    name: string
  }
): BreadcrumbData[] => {
  return [
    shop
      ? {
          name: shop.name,
          path: `/shop/${shop.id}/`,
        }
      : [],
    {
      name: nickname,
      path: `/${username}/`,
    },
    {
      name: 'お気に入りフォルダ一覧',
      path: `/${username}/favorite/`,
    },
    { name: folderName },
  ].flat()
}
